import React from 'react';
import { Search, ChevronLeft, ChevronRight, Info } from 'lucide-react';
import './pricing-premium.css';

/* PRICING-UI-PREMIUM-002 — shared primitives for the Pricing & Costs pages (presentation only). */

export const PcButton = ({ variant = 'secondary', icon: Icon, children, className = '', ...p }) => (
  <button type="button" className={`pc-btn pc-btn-${variant} ${className}`} {...p}>{Icon && <Icon className="w-4 h-4" />}{children}</button>
);

export const PcIconButton = ({ icon: Icon, tone = '', className = '', ...p }) => (
  <button type="button" className={`pc-icon-btn ${tone} ${className}`} {...p}><Icon className="w-4 h-4" /></button>
);

export const PcBadge = ({ tone = 'neutral', dot = false, children, className = '', ...p }) => (
  <span className={`pc-badge pc-badge-${tone} ${className}`} {...p}>{dot && <i className="pc-dot" />}{children}</span>
);

export const PcSearch = ({ className = '', ...p }) => (
  <div className={`pc-search ${className}`}><Search className="w-4 h-4" /><input type="text" {...p} /></div>
);

export const PcSelect = ({ children, className = '', ...p }) => <select className={`pc-select ${className}`} {...p}>{children}</select>;

export const PcTip = ({ text, testId, align = '' }) => (
  <span className={`pc-tip ${align}`} data-tip={text} aria-label={text} tabIndex={0} data-testid={testId}><Info className="w-3.5 h-3.5" /></span>
);

export const PcSkeletonRows = ({ rows = 5, cols = 6, testId }) => Array.from({ length: rows }).map((_, i) => (
  <tr key={`sk-${i}`} className="pc-skel-row" data-testid={i === 0 ? testId : undefined}>
    {Array.from({ length: cols }).map((__, j) => <td key={j}><span className="pc-skel" style={{ width: `${45 + ((i * 7 + j * 13) % 45)}%` }} /></td>)}
  </tr>
));

const HUES = [243, 199, 160, 38, 330, 262, 174, 24, 210, 350];
export const avatarColor = (label = '') => { let h = 0; for (const ch of String(label)) h = (h * 31 + ch.charCodeAt(0)) >>> 0; return `hsl(${HUES[h % HUES.length]} 68% 58%)`; };
export const PcAvatar = ({ label = '', size = 'sm', className = '' }) => (
  <span className={`pc-avatar pc-avatar-${size} ${className}`} style={{ background: avatarColor(label) }} aria-hidden>{String(label).trim().charAt(0).toUpperCase() || '?'}</span>
);

const pageWindow = (page, pages) => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i);
  const set = new Set([0, pages - 1, page - 1, page, page + 1].filter((p) => p >= 0 && p < pages));
  const out = []; let prev = -1;
  for (const p of [...set].sort((a, b) => a - b)) { if (prev >= 0 && p - prev > 1) out.push('…'); out.push(p); prev = p; }
  return out;
};

export const PcPager = ({ page, pages, onChange, testPrefix = 'pager' }) => (
  <nav className="pc-pager" aria-label="Pagination" data-testid={`${testPrefix}-pager`}>
    <button type="button" disabled={page <= 0} onClick={() => onChange(page - 1)} aria-label="Previous page" data-testid={`${testPrefix}-prev`}><ChevronLeft className="w-4 h-4" /></button>
    {pageWindow(page, Math.max(pages, 1)).map((p, i) => p === '…' ? <span key={`e${i}`} className="pc-ellipsis">…</span>
      : <button type="button" key={p} className={p === page ? 'is-current' : ''} onClick={() => onChange(p)} aria-current={p === page ? 'page' : undefined} data-testid={`${testPrefix}-page-${p + 1}`}>{p + 1}</button>)}
    <button type="button" disabled={page >= pages - 1} onClick={() => onChange(page + 1)} aria-label="Next page" data-testid={`${testPrefix}-next`}><ChevronRight className="w-4 h-4" /></button>
  </nav>
);
